let contentStore = {
    all: [],
    contents_exclude_location: {}
};

export function set(_contents) {
    contentStore.all = _contents;
}

export function get() {
    return contentStore.all;
}

export function setExcludeLocation(_contents) {
    contentStore.contents_exclude_location = _contents;
}

export function getExcludeLocation() {
    return contentStore.contents_exclude_location;
}

